<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12" class="py-0">
        <el-table
          style="width: 100%"
          class="elevation-1 rounded player-scout-table mt-2"
          @sort-change="onSortChange($event)"
          @row-click="onRowClick($event)"
          :data="paginatedPlayers"
          :size="'mini'"
          :header-cell-class-name="'body-2 primary--text pl-0 py-0'"
          :cell-style="{padding: '0', height: '20px'}"
          :cell-class-name="`px-0 ${darkMode ? 'primary--text' : ''}`"
          :empty-text="$t('general.noData')"
          :height="$vuetify.breakpoint.lgAndDown ? 515 : 700"
          ref="playerScouTableRef"
        >
          <el-table-column
            v-if="isHeaderActive({value:'playerName'})"
            :width="$vuetify.breakpoint.smAndDown ? '235' : '285'"
            fixed
            prop="playerName"
          >
            <template slot="header" slot-scope="scope">
              <div v-if="selectable" class="d-flex" @click.exact.stop="">
                <v-checkbox v-model="selectAllPageModel" hide-details dense class="ma-0 pa-0"
                  @change="sellectAllPlayersOnPage()"></v-checkbox>
                <span class="body-2">{{$t('playerScout.playerName')}}</span>
              </div>
              <div v-else class="d-flex pl-3" @click.exact.stop="">
                <span class="body-2">{{$t('playerScout.playerName')}}</span>
              </div>
            </template>
            <template slot-scope="item">
              <div class="d-flex align-start">
                <div v-if="item.row.id && selectable" class="d-flex justify-center align-self-center" @click.exact.stop="">
                  <v-checkbox v-model="item.row.selected" hide-details dense class="ma-0 pa-0"
                    @change="onPlayerSelection($event,item.row)"></v-checkbox>
                </div>
                <div class="d-flex justify-center">
                  <v-badge
                    color="red"
                    :content="$t('general.new')"
                    overlap
                    offset-x="30"
                    offset-y="20"
                    bottom
                    left
                    v-if="item.row.addedLastWeek"
                  >
                    <img
                      :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/' + item.row.id + '.png'"
                      :width="'50px'"
                      :height="'50px'"
                      contain
                      @error="onImageLoadFailure($event,'player')"
                      v-if="!$vuetify.breakpoint.smAndDown"
                    />
                  </v-badge>
                  <img
                    :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/' + item.row.id + '.png'"
                    :width="'50px'"
                    :height="'50px'"
                    contain
                    @error="onImageLoadFailure($event,'player')"
                    v-if="!$vuetify.breakpoint.smAndDown && !item.row.addedLastWeek"
                  />
                </div>
                <div class="d-flex flex-column ml-3 w-45 flex-grow-1">
                  <router-link
                    :to="'/player/'+item.row.id"
                    target="_blank"
                    @click.native="$event.stopImmediatePropagation()"
                    class="d-flex"
                  >
                    <span
                      class="font-weight-medium body-1 text-ellipsis" :class="darkMode ? 'primary--text' : 'secondary--text text--darken-2'"
                    >{{item.row.playerName}}</span>

                  </router-link>
                  <div class="d-flex align-center py-1">
                    <div class="d-flex justify-center mr-2">
                      <DriblabCountryFlag v-if="item.row.countryCode" :iso="item.row.countryCode" :key="item.row.countryCode" ></DriblabCountryFlag>
                      <DriblabCountryFlag v-if="item.row.secondCountryCode" :iso="item.row.secondCountryCode" :key="item.row.secondCountryCode"></DriblabCountryFlag>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-center flex-column align-start ml-2" v-bind:class="{'w-25':!$vuetify.breakpoint.smAndDown ,'w-30':$vuetify.breakpoint.smAndDown}">
                  <v-chip
                    class="monospace-font"
                    style="height: 20px; margin: 1px"
                    :color="getPositionChip(item.row.fieldPositionId)"
                    text-color="white"
                    small
                  >{{ getPositionCode(item.row.fieldPositionId) }}</v-chip>
                  <v-chip
                    class="monospace-font"
                    v-if="item.row.secondFieldPositionId"
                    style="height: 20px; margin: 1px"
                    :color="getPositionChip(item.row.secondFieldPositionId)"
                    text-color="white"
                    small
                  >{{ getPositionCode(item.row.secondFieldPositionId) }}</v-chip>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="isHeaderActive({value:'seasonYear'})"
            sortable
            prop="seasonYear"
            align="center"
            width="155"
            :label="$t('playerScout.seasonYear')"
          >
            <template slot-scope="item">
              <div class="d-flex flex-column">
                <span class="body-2 font-weight-bold">{{item.row.seasonYear}}</span>
                <v-divider class="mx-10"></v-divider>
                <div class="d-flex align-center">
                  <img
                    :title="item.row.leagueName"
                    :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + item.row.leagueId + '.png'"
                    contain
                    width="15"
                    class="mr-2"
                    @error="onImageLoadFailure($event,'league')"
                  />
                  <span class="body-2 subheader-font">{{item.row.leagueName}}</span>
                </div>
                <div class="d-flex align-center mb-1">
                  <img
                    :title="item.row.teamName"
                    :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + item.row.teamId + '.png'"
                    style="height: 16px; width: 16px;"
                    class="mr-2"
                    @error="onImageLoadFailure($event,'team')"
                  />
                  <span
                    class="body-2 subheader-font"
                  >{{item.row.teamName}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'marketValue'})"
            sortable
            width="140"
            prop="marketValue"
            align="center"
            class-name="font-weight-medium"
            :label="$t('playerScout.marketValue')"
          >
            <template slot="header" slot-scope="scope">
              <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{scope.column.label}}</span>
                </template>
                <span class="black--text body-1">{{$t('playerScout.marketValue')}}</span>
              </v-tooltip>
            </template>
            <template slot-scope="item">
              <div v-if="item.row.marketValue" class="d-flex align-center justify-center pr-2">
                <span class="font-weight-bold">{{currentUserCurrencySymbol}}</span>
                <div 
                  class="ml-1 font-weight-bold"
                >{{ item.row.marketValue * 1000 | formatCash(currentUserRate) }}</div>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'greatestContractDate'})"
            sortable
            prop="greatestContractDate"
            width="130"
            align="center"
            class-name="font-weight-medium"
            :label="$t('playerDetail.contractEnd')"
          >
            <template slot-scope="item">
              <span>{{item.row.greatestContractDate ? `${item.row.greatestContractDate.slice(-10)}'` : "-"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'age'})"
            sortable
            prop="age"
            width="95"
            align="center"
            class-name="font-weight-medium"
            :label="$t('playerScout.age')"
          >
            <template slot-scope="item">
              <span class="font-weight-bold mr-1">{{item.row.age}}</span>
              <span>{{item.row.dob ? `(${item.row.dob.slice(-2)}')` : "-"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'height'})"
            sortable
            prop="height"
            width="110"
            align="center"
            class-name="font-weight-medium"
            :label="$t('playerScout.height')"
          >
            <template slot-scope="item">
              <span class="font-weight-bold mr-1">{{item.row.height ? item.row.height : "-"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'side'})"
            sortable
            align="center"
            width="100"
            prop="side"
            :label="$t('playerScout.side')"
          >
            <template slot-scope="item">
              <v-icon
                :color="item.row.side.includes('Left') ? 'secondary' : 'lightSecondary lighten-3'"
                style="transform: scaleY(-1)"
                small
              >subdirectory_arrow_left</v-icon>
              <v-icon
                :color="item.row.side.includes('Centre') ? 'secondary' : 'lightSecondary lighten-3'"
                small
              >arrow_upward</v-icon>
              <v-icon
                :color="item.row.side.includes('Right') ? 'secondary' : 'lightSecondary lighten-3'"
                style="transform: scaleY(-1)"
                small
              >subdirectory_arrow_right</v-icon>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'tmFoot'})"
            sortable
            align="center"
            width="130"
            prop="tmFoot"
            :label="$t('playerDetail.strongFoot')"
          >
            <template slot-scope="item">
              <span v-if="item.row.tmFoot">{{$t(`general.${item.row.tmFoot}`)}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'gbeScore'}) && userHasRole('ROLE_EVENTING_DATA')"
            sortable
            align="center"
            min-width="120"
            prop="gbeScore"
            class-name="font-weight-medium"
            :label="$t('playerScout.gbeScore')"
          >
            <template slot="header" slot-scope="scope">
              <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{scope.column.label}}</span>
                </template>
                <span class="black--text body-1">{{$t('playerScout.gbeScoreTooltip')}}</span>
              </v-tooltip>
            </template>
            <template slot-scope="item">
              <span class="body-2 font-weight-medium text-ellipsis d-flex align-center justify-center text-center">
                <v-icon small class="mr-1" :color="item.row.gbeScore >= 15 ? 'success' : (item.row.gbeScore >= 10 ? 'warning' : 'error')">
                  {{item.row.gbeScore >= 15 ? 'check' : (item.row.gbeScore >= 10 ? 'help_outline' : 'close')}}</v-icon>
                <v-chip outlined :color="item.row.gbeScore >= 15 ? 'success' : (item.row.gbeScore >= 10 ? 'warning' : 'error')" x-small>
                  <span class="monospace-font" v-if="item.row.gbeScore < 999">{{item.row.gbeScore}}</span>
                  <span class="monospace-font" v-if="item.row.gbeScore >= 999">{{$t("gbe.autopass")}}</span>
                </v-chip>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'gamesPlayed'})"
            sortable
            align="center"
            min-width="100"
            prop="gamesPlayed"
            class-name="full-size-cell"
            :label="$t('playerScout.games')"
          >
            <template slot-scope="item">
              <div class="w-100 h-100 d-flex align-center justify-center primary--text" v-bind:style="{'background-color':getBackgroundColorFixedColumns(item.row,'gamesPlayed')}">
                {{ item.row.gamesPlayed }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'minutesPlayed'})"
            sortable
            :align="$vuetify.breakpoint.smAndDown ? 'left' : 'center'"
            min-width="120"
            prop="minutesPlayed"
            class-name="full-size-cell"
            :label="$t('playerScout.minutes')"
          >
            <template slot-scope="item">
              <div class="w-100 h-100 d-flex align-center justify-center primary--text" 
                v-bind:style="{'background-color':getBackgroundColorFixedColumns(item.row,'minutesPlayed')}">
                {{ item.row.minutesPlayed }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'yellowCards'})"
            sortable
            :align="$vuetify.breakpoint.smAndDown ? 'left' : 'center'"
            min-width="120"
            prop="yellowCards"
            class-name="full-size-cell"
            :label="$t('statsNaming.YellowCards')"
          >
            <template slot-scope="item">
              <div class="w-100 h-100 d-flex align-center justify-center primary--text" 
              v-bind:style="{'background-color':getBackgroundColorFixedColumns(item.row,'yellowCards')}">
                <span v-if="item.row.yellowCards">{{ item.row.yellowCards }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isHeaderActive({value:'redCards'})"
            sortable
            :align="$vuetify.breakpoint.smAndDown ? 'left' : 'center'"
            min-width="120"
            prop="redCards"
            class-name="full-size-cell"
            :label="$t('statsNaming.RedCards')"
          >
            <template slot-scope="item">
              <div class="w-100 h-100 d-flex align-center justify-center primary--text" 
              v-bind:style="{'background-color':getBackgroundColorFixedColumns(item.row,'redCards')}">
                <span v-if="item.row.redCards">{{ item.row.redCards }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeHeadersSorted.length > 0"
            v-for="cat in activeHeadersSorted"
            :key="cat[0]"
            :label="$t('faq.metrics.categories.' + cat[0])"
            align="center"
            class-name="category-header">
            <template slot="header" slot-scope="scope">
              <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-if="cat[2] && cat[2].icon" :style="cat[2].icon.startsWith('fa-') ? 'font-size: 10px' : 'font-size: 14px'" color="white" class="mx-1">
                    {{ cat[2].icon }}
                  </v-icon>
                  <span v-bind="attrs" v-on="on">{{ $t('faq.metrics.categories.' + cat[0]) }}</span>
                </template>
                <div class="d-flex flex-column black--text body-1">
                  <span class="font-weight-bold">{{ $t('faq.metrics.categories.' + cat[0]) }}</span>
                  <span class="monospace-font body-2">{{ cat[2].name }}</span>
                </div>
              </v-tooltip>
            </template>
            <el-table-column
              v-for="(header, i) in cat[1]"
              align="center"
              :key="header.code"
              :prop="header.value"
              :label="header.code"
              :width="header.width"
              sortable="custom"
              class-name="full-size-cell"
              >
              <template slot="header" slot-scope="scope">
                <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="body-2" style="font-size: 11px !important;" v-bind="attrs" v-on="on">
                      {{ (showAbbreviations && $t('statsNaming.abbr.' + scope.column.label) ? $t('statsNaming.abbr.' + scope.column.label) : $t('statsNaming.' + scope.column.label)) + (header.pAdj ? '*' : '') }}
                    </span>
                  </template>
                  <div class="d-flex flex-column black--text body-1">
                    <span class="font-weight-bold">{{ $t('statsNaming.' + scope.column.label) }}</span>
                    <span class="monospace-font body-2">{{ header.product.name }}</span>
                    <span v-html="$t('statsNaming.description.' + scope.column.label)" v-if="$t('statsNaming.' + scope.column.label) !== $t('statsNaming.description.' + scope.column.label)"></span>
                  </div>
                </v-tooltip>
              </template>
              <template slot-scope="item">
                <div class="w-100 h-100 d-flex align-center justify-center" :class="header.code.includes('Score') ? 'grey--text text--darken-4' : 'primary--text'"
                  v-bind:style="{'background-color':getBackgroundColor(item.row, header.statId, header.isR, header.code.includes('Score'))}">
                  {{ item.row.stats.find(s=> s.id === header.statId).tV }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div v-if="pagination && pagination.pageCount > 1" class="text-center monospace-font pt-2">
          <v-pagination class="monospace-font" circle  color="secondary" v-model="pagination.page" :length="pagination.pageCount" @input="onPageChange($event)"></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {userHasRole, getChipColorByPosition, getCurrencies, formatCash, colorScale, getFieldPositionIdByDefaultCode, getPositionCode} from '../../utils/functions';
import DriblabCountryFlag from "../base/DriblabCountryFlag";

export default {
  name: "PlayerScoutTable",
  components: {
    DriblabCountryFlag
  },
  props:{
    players:{
      type:Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    accumulation:{
      type: Boolean,
      required: false
    },
    selectable:{
      type:Boolean,
      default: true
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    pagination: {
      type: Object,
      required: false
    },
    showAbbreviations: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  data() {
    return {
      paginatedPlayers: [],
      activeHeaders: [],
      selectAllPageModel: false,
    };
  },
  filters: {
    formatCash(n,rate) {
      return formatCash(n * rate)
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserCurrency(){
      return this.$store.getters["auth/currency"];
    },
    currentUserRate(){
      let rate = this.currentUserCurrency === "EUR" ? 1 : this.$store.getters["exchange/rates"][this.$store.getters["auth/currency"]];
      return rate ? rate : 1;
    },
    currencies(){
      return getCurrencies();
    },
    currentUserCurrencySymbol(){
      let currentCurrencyObj = _.find(this.currencies,(c) => c.code === this.currentUserCurrency)
      return currentCurrencyObj.symbol;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark
    },
    activeHeadersSorted(){
      let sortable = [];
      let scoreCategory;
      for (var h in this.activeHeaders) {
        if(h != "Score")
          sortable.push([h, this.activeHeaders[h], this.activeHeaders[h].length ? this.activeHeaders[h][0].product : null]);
        else
          scoreCategory = [h, this.activeHeaders[h], this.activeHeaders[h].length ? this.activeHeaders[h][0].product : null];
      }
      if(scoreCategory){
        //Set Score category to the end
        sortable.push(scoreCategory);
      }
      return sortable;
    }
  },
  mounted() {
    //Show active headers (stats clicked on the top panel). Remove fixed from activeHeaders
    this.activeHeaders = this.headers.filter(s=> !s.fixed).reduce((categories, header) => {
      const cat = (categories[header.cat] || []);
      cat.push(header);
      categories[header.cat] = cat;
      return categories;
    }, {});

    this.paginatedPlayers = this.players;
    //If all players of the current page are selected, then set true checkbox
    this.selectAllPageModel = !this.players.filter(p=> !p.selected).length > 0;

    if(this.pagination && this.pagination.sortBy){
      setTimeout(() => {
        let prop = this.pagination.sortBy.split(",")[0];
        let order = this.pagination.sortBy.split(",")[1];
        this.$refs.playerScouTableRef.sort(prop, order)
      }, 1);

    }

  },
  async created() {},
  methods: {
    onPageChange(page) {
      this.paginatedPlayers = this.players;
      this.$emit("paginationChange", this.pagination);
    },
    onSortChange(event) {
      let statToSort = this.headers.find(h => h.value === event.prop);
      let newOrder = event.prop + "," + event.order;
      if(statToSort.stID){
        newOrder += "," + statToSort.stID;
      }else{
        newOrder += ",0";
      }
      if(this.pagination && newOrder != this.pagination.sortBy){
        this.pagination.sortBy = newOrder;
        this.$emit("paginationChange", this.pagination);
      }
    },
    onRowClick(event) {
      event.selected = !event.selected
      this.onPlayerSelection(event.selected,event)
    },
    onPlayerSelection(selected, player){
      console.log("onPlayerSelection");
      console.log(selected);
      console.log(player);
      console.log(this.paginatedPlayers[0]);
      let playerClicked = this.paginatedPlayers.filter(p=> p.id === player.id && p.teamId === player.teamId && p.seasonId === player.seasonId)
                                               .map(p=> ({id: p.id, teamId: p.teamId, seasonId: p.seasonId}));
      if(selected){
        this.$emit('addSelectedPlayersChange', playerClicked);
      }else{
        this.$emit('removeSelectedPlayersChange', playerClicked);
      }

    },
    sellectAllPlayersOnPage(){
      console.log("sellectAllPlayersOnPage");
      this.paginatedPlayers = this.paginatedPlayers.map(p=> { return {...p, selected: this.selectAllPageModel}});
      let playersSelected = this.paginatedPlayers.map(p=> ({id: p.id, teamId: p.teamId, seasonId: p.seasonId}));
      if(this.selectAllPageModel){
        //Set all page as selectedPlayers
        this.$emit('addSelectedPlayersChange', playersSelected);
      }else{
        //Clear selectedPlayers array
        this.$emit('removeSelectedPlayersChange', playersSelected);
      }

    },
    userHasRole(role){
      return userHasRole(this.currentUser,role);
    },
    onImageLoadFailure(event, type) {
      if (type === "league" || type === "team") {
        event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
      } else if (type === "player") {
        event.target.src =
          "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png";
      }
    },
    getPositionChip(position) {
      return getChipColorByPosition(position);
    },
    getFieldPositionIdByDefaultCode(position) {
      return getFieldPositionIdByDefaultCode(position);
    },
    getPositionCode(position) {
      return getPositionCode(this.currentUser.fieldPositionCodeId, position);
    },
    isHeaderActive(header) {
      let isActive = _.some(this.headers, h =>
        _.isEqual(h.value, header.value)
      );
      return isActive;
    },
    getBackgroundColorFixedColumns(item, property){
      let allData = _.map(this.paginatedPlayers,(t) => t[property]);
      let max = _.max(allData);
      let min = _.min(allData);
      let data = item[property];
      let percentageOfColor = (data - min) / (max - min);

      return `rgba(51, 102, 255,${percentageOfColor / 7})`;
    },
    getBackgroundColor(item, statId, isReverse = false, isScore = false){ //property
      let statObject = item.stats.find(s => s.id === statId);
      if(isScore){
        if (statObject.v === 0)
          return '';
        //minDomain=0, maxDomain=100, steps=90
        let color = colorScale(0, 100, statObject.v, 90);
        return color;
      }else {
        let allData = _.map(this.paginatedPlayers,(t) => t.stats.find(s=> s.id === statId).v);
        let max = _.max(allData);
        let min = _.min(allData);
        let data = statObject.v;
        let percentageOfColor = (data - min) / (max - min);

        if(isReverse){
          percentageOfColor = 1 - percentageOfColor;
        }
        return `rgba(51, 102, 255,${percentageOfColor / 7})`
      }
    },
    calculateDiffXG(item){
      let decimals = this.accumulation ? 1 : 2;
      let xg = item.row.xG ? Number(item.row.xG.toFixed(decimals)) : 0.0
      let npg = item.row.npg ? Number(item.row.npg.toFixed(decimals)) : 0.0
      return Number((npg - xg).toFixed(decimals));
    },
    calculateDiffXA(item){
      let decimals = this.accumulation ? 1 : 2;
      let xa = item.row.xA ? Number(item.row.xA.toFixed(decimals)) : 0.0
      let assists = item.row.assists ? Number(item.row.assists.toFixed(decimals)) : 0.0;
       return Number((assists - xa).toFixed(decimals));
    },
  },
};
</script>

<style lang="scss">

/* Make tables compatible safari, No dislocation */
.el-table__body {
  width: 100%;
  table-layout: fixed;
}

.player-scout-table{
  td.full-size-cell{
    height: 100%;
    padding: 0 !important;
    >.cell{
      height: 100% !important;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  td.full-size-cell{
    &.left{
      .cell{
        justify-content: flex-start !important;
      }
    }
    &.right{
      .cell{
        justify-content: flex-end !important;
      }
    }
    &.center{
      .cell{
        justify-content: center !important;
      }
    }
  }
  .el-table__header {
    th {
      padding: 0;
      &.category-header{
        background-color: var(--v-primary-base) !important;
        font-weight: bold !important;
        >*{
          color:white !important;
        }
      }
    }
  }

  .el-table{
    .cell{
      padding: 0;
    }
  }

}
.theme--dark{
  .cell{
    >.primary--text:not(.score-cell){
      color: white !important;
    }
  }
  .el-table__header {
    th {
      padding: 0;
      &.category-header{
        background-color: var(--v-secondary-base) !important;
        font-weight: bold !important;
        >*{
          color:white !important;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/player/PlayerScoutTable.vue